import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
  margin: ${p => p.$margin || '48px 0'};
`;

const Line = styled.span`
  flex: 1;
  height: 1px;
  background: ${p => p.$gold
    ? 'linear-gradient(90deg, transparent 0%, rgba(230,199,126,0.35) 50%, transparent 100%)'
    : p.theme.colors.lineFaint};
  max-width: ${p => p.$short ? '60px' : 'none'};
`;

const Mark = styled.span`
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  color: ${p => p.$gold ? p.theme.colors.starGold : p.theme.colors.textMuted};
  font-family: ${p => p.theme.fonts.mono};
  user-select: none;
`;

/**
 * HairlineDivider — 中央に星 ✦ を置く区切り線
 * @param {string} mark - 中央のシンボル (✦ ☾ ── 等) または短いラベル
 * @param {boolean} gold - 黄金線にする
 * @param {boolean} short - 線を短く (centered)
 * @param {string} margin - 上下マージン上書き
 */
const HairlineDivider = ({ mark = '✦', gold = false, short = false, margin }) => (
  <Wrap $margin={margin}>
    <Line $gold={gold} $short={short} />
    <Mark $gold={gold}>{mark}</Mark>
    <Line $gold={gold} $short={short} />
  </Wrap>
);

export default HairlineDivider;
